import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { coercePercentage } from '@business/utils';

@Component({
  selector: 'progress-bar',
  imports: [MatProgressBarModule],
  template: `
    @if (isDeterminate()) {
      <mat-progress-bar class="progress-bar__inner" mode="determinate" [value]="this.progressValue()" />
    } @else {
      <mat-progress-bar class="progress-bar__inner" mode="indeterminate" />
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'progress-bar',
    '[class.progress-bar--determinate]': 'isDeterminate()',
    '[class.progress-bar--indeterminate]': 'isIndeterminate()'
  }
})
export class ProgressBarComponent {
  mode = input<'determinate' | 'indeterminate'>('indeterminate');

  isDeterminate = computed<boolean>(() => this.mode() === 'determinate');
  isIndeterminate = computed<boolean>(() => this.mode() === 'indeterminate');

  progressValue = input(0, {
    transform: (value: number) => coercePercentage(value)
  });
}
